import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import UserConsumablesForm from "./user-consumables-form";
import UserConsumablesData from "./user-consumables-data";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import { reduce } from "et3-type-guards";
import getUserConsumablesStore from "../../../stores/user-store/consumables-store";
import { useLocation } from "react-router-dom";

const UserConsumables = withLiteObserverAndTheme(() => {
  const location = useLocation();
  React.useEffect(() => {
    const search = reduce(() => location.search, "");
    getCoreHistoryStore().setPageName("USER_CONSUMABLES", "USER_CONSUMABLES");
    getUserConsumablesStore().checkURLSearch(search);
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("CONSUMABLES")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserConsumablesForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserConsumablesData />
    </ET3PageDiv>
  );
});
export default UserConsumables;
